module.exports = __webpack_public_path__ + "media/celebrate.642229b2.mp3";